import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import {ProductWrap} from './context/product_provider';
import { CartProvider } from './context/cart_context';
import { Provider } from 'react-redux';
import {store} from '../src/store/store'
import {stripePromise} from '../src/stripe/strip.utils'

import { Elements } from '@stripe/react-stripe-js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store = {store}>
    <BrowserRouter>
    {/*<UserWrap>*/}
      <ProductWrap>
        <CartProvider>
            <Elements stripe={stripePromise}>
            <App />
            </Elements>
        </CartProvider>
      </ProductWrap>
      {/*</UserWrap>*/}
    </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
